import React from 'react';
import { Flex, Heading, Text } from '@highereducation/hen-ui';
import type { Step } from '../../types/types';

interface StepHeaderProps {
  step: Step;
  isFullPageExp: boolean;
}

export const StepHeader: React.FC<StepHeaderProps> = ({
  step,
  isFullPageExp,
}) => {
  if (!step.title) return null;

  return (
    <Flex direction='column' justify='center' align='start' gap='xs'>
      <Heading
        variant={isFullPageExp ? 'h1' : 'h3'}
        className={
          isFullPageExp
            ? 'de-step-title text-h3 leading-h3 md:text-h2 md:leading-h2'
            : 'de-step-title'
        }
      >
        {step.title}
      </Heading>
      {step.subtitle && (
        <Text variant='b3' color='default' data-test='de-step-subtitle'>
          {step.subtitle}
        </Text>
      )}
    </Flex>
  );
};
